import { useEffect, useState } from "react";

/** Largeur à partir de laquelle on passe en mise en page « grand écran » (barre latérale). */
export const DESKTOP_QUERY = "(min-width: 900px)";

export function useMediaQuery(query: string): boolean {
  const get = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState<boolean>(get);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);
  return matches;
}

/** true sur tablette paysage / ordinateur : navigation latérale, grilles multi-colonnes. */
export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY);
}
